import React from 'react';
import { Sparkles } from 'lucide-react';
import { useTranslation } from '@/i18n';

interface PromptHintsProps {
  /** Called with the chosen example prompt (sent through the normal send path). */
  onSelect: (prompt: string) => void;
  /** Disable the chips while a generation is in flight. */
  disabled?: boolean;
  className?: string;
}

/**
 * STORY-152 — starter-prompt hints shown on an empty chat. Clicking a chip sends
 * that example immediately. Titles + examples come from i18n (EN/RU), never
 * hard-coded here.
 */
export const PromptHints: React.FC<PromptHintsProps> = ({ onSelect, disabled, className }) => {
  const { t } = useTranslation();
  const hints = (t as any).promptHints as { title: string; examples: string[] } | undefined;
  const examples = hints?.examples ?? [];

  if (examples.length === 0) return null;

  return (
    <div className={`mt-6 ${className || ''}`}>
      <div className="flex items-center justify-center gap-1.5 mb-3 text-xs font-medium uppercase tracking-wide text-gray-400 dark:text-gray-500">
        <Sparkles className="w-3.5 h-3.5" />
        {hints?.title || 'Try one of these'}
      </div>
      <div className="flex flex-wrap justify-center gap-2">
        {examples.map((example, i) => (
          <button
            key={i}
            type="button"
            onClick={() => onSelect(example)}
            disabled={disabled}
            className="px-3 py-1.5 text-sm text-left text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-800 hover:bg-blue-50 hover:text-blue-700 dark:hover:bg-blue-900/30 dark:hover:text-blue-300 border border-gray-200 dark:border-gray-700 rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {example}
          </button>
        ))}
      </div>
    </div>
  );
};
